
import Vue from 'vue'
import ConfirmSimple from '@/components/ConfirmSimple.vue'
import ExpandableCheckbox from '@/components/ExpandableCheckbox.vue'

export default Vue.extend({
  name: 'UserSettings',

  components: {
    ConfirmSimple,
    ExpandableCheckbox,
  },

  props: {
    value: {},
    saveChangesLoading: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    value: {
      handler: function () {
        this.isFormTouched = JSON.stringify(this.value) !== this.touchCompareObject;
      },
      deep: true,
    }
  },

  async mounted() {
    const promises = [
      this.$api
        .get('/contents/static/user')
        .then((result) => {
          this.consentShort = result.data.short
          this.consentLong = result.data.long
        })
    ]

    Promise.all(promises).then(() => (this.contentLoaded = true))
  },

  data: function () {
    const nameRegex = /^\p{L}+$/u;

    return {
      consentShort: '',
      consentLong: '',
      contentLoaded: false,
      privacyPolicy: false,
      userSettingsFormIsValid: false,
      removeMyAccountConfirm: false,
      touchCompareObject: JSON.stringify(this.value),
      isFormTouched: false,
      firstnameRules: [
        (v: string) => !!v || 'First name is required.',
        (v: string) => nameRegex.test(v) || 'First name must contain only letters.'
      ],
      lastnameRules: [
        (v: string) => !!v || 'Last name is required.',
        (v: string) => nameRegex.test(v) || 'Last name must contain only letters.'
      ],
      countryRules: [(v: string) => !!v || 'Country is required.'],
      nicknameRules: [
        (v: string) => !!v || 'Nickname is required.',
        (v: string) =>
          v.match(/^[a-z0-9.-]+$/) !== null ||
          'Use only small letters, digits, hyphen and dots.',
      ],
      passwordRules: [
        (v: string) =>
          !v ||
          v.length === 0 ||
          v.length >= 8 ||
          'Password must be at least 8 characters long.',
      ],
      facebookUrlRules: [
        (v: string) =>
          v.length === 0 ||
          v.startsWith('https://facebook.com') ||
          'Facebook link must start with https://facebook.com',
      ],
      instagramUrlRules: [
        (v: string) =>
          v.length === 0 ||
          v.startsWith('https://instagram.com') ||
          'Instagram link must start with https://instagram.com',
      ],
      twitterUrlRules: [
        (v: string) =>
          v.length === 0 ||
          v.startsWith('https://x.com') ||
          'Twitter/X link must start with https://x.com',
      ],
      privacyPolicyRules: [
        (v: boolean) => !!v || 'You have to confirm this consent.',
      ],
    }
  },

  methods: {
    saveChanges: function () {
      (this.$refs.userSettingsFormRef as any).validate()
      if (!this.userSettingsFormIsValid) {
        this.$store.dispatch(
          'alert/error',
          'There are some problems with the form.'
        )
        return
      }
      this.$emit('saveChangesClicked')
      this.privacyPolicy = false
      ;(this.$refs.userSettingsFormRef as any).resetValidation()
    },
  },
})
